import React, { useCallback, useEffect, useState } from "react";
import { Alert, Container, Spinner } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import { useParams, useLocation } from "react-router-dom";
import { getAgencyLTA } from "common/services/ltas.service";
import { normalize } from "common/lib/normalize";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import LTAContent from "pages/LTAs/ViewLTA/LTAContent";
import UpdateLTA from "./UpdateLTA";

const ViewAgencyLTA = () => {
  const location = useLocation();
  const { id: ltaId } = useParams();
  usePageActivity(location.pathname, "View Agency LTA", ltaId);

  const [lta, setLta] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchLta = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const response: any = await getAgencyLTA(ltaId, {});
      setLta(normalize(response.data));
    } catch (e) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [ltaId]);

  useEffect(() => {
    fetchLta();
  }, [fetchLta]);

  document.title = "LTA Details | CIMS";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="LTA Details"
          pageTitles={[
            { title: "Dashboard", link: "/dashboard" },
            { title: "LTAs", link: "/agency-data/ltas" },
          ]}
          back
        />

        {loading && (
          <div className="text-center py-5">
            <Spinner color="primary" />
          </div>
        )}

        {!loading && error && (
          <Alert color="danger">
            This agreement could not be loaded. It may have been deleted, or you
            may not have permission to view it.
          </Alert>
        )}

        {!loading && !error && lta && (
          <LTAContent
            lta={lta}
            onChanged={fetchLta}
            controller="agency"
            UpdateComponent={UpdateLTA}
          />
        )}
      </Container>
    </div>
  );
};

export default ViewAgencyLTA;
